import React from 'react';

import './SortationOptions.scss';

type SortationOptionsProps = Omit<
  React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>,
  'className' | 'ref'
> & {
  innerRef?: React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>['ref'];
};

export const SortationOptions = ({ children, innerRef, ...props }: SortationOptionsProps) => {
  return (
    <div className="sortation-widget-options" ref={innerRef} {...props}>
      {children}
    </div>
  );
};
